function createStarrySky(sectionId) {
  function createStars(className, count, size) {
    const stars = document.querySelector(`#shopify-section-${sectionId} ${className}`);
    if (!stars) return;
    for (let i = 0; i < count; i++) {
      const star = document.createElement('div');
      star.className = 'star';
      star.style.width = `${size}px`;
      star.style.height = `${size}px`;
      star.style.top = `${Math.random() * 100}%`;
      star.style.left = `${Math.random() * 100}%`;
      star.style.animationDelay = `${Math.random() * 4}s`;
      stars.appendChild(star);
    }
  }

  function createShootingStars() {
    const container = document.querySelector(`#shopify-section-${sectionId} .shooting-stars`);
    if (!container) return;
    for (let i = 0; i < 5; i++) {
      const star = document.createElement('div');
      star.className = 'shooting-star';
      star.style.bottom = `${Math.random() * 100}%`;
      star.style.left = `${Math.random() * 100}%`;
      star.style.width = `${50 + Math.random() * 80}px`;
      star.style.animationDuration = `${3 + Math.random() * 4}s`;
      star.style.animationDelay = `${Math.random() * 5}s`;
      container.appendChild(star);
    }
  }

  createStars('.stars', 300, 1);
  createStars('.stars1', 200, 2);
  createStars('.stars2', 100, 3);
  createShootingStars();
}